import React, { useState } from "react"
import { defineMessages, FormattedMessage } from "react-intl"
import OrderStatusSelect from "../../order/statusesselection.component.jsx"

type onChangeParam = {
    statusID: string
}
type Props = {
    onChange: (param: onChangeParam) => void
    object: string
}

const messages = defineMessages({
    order_status_label: {
        id: "bulk.modal.operations.orders_set_status",
        defaultMessage: "Set order status",
    },
    refresh_description: {
        id: "bulk.operations.orders_update_status_refresh.description",
        defaultMessage: "When the bulk operation has finished, refresh to see the updated status.",
    },
})

const OrdersUpdateStatus = (props: Props) => {
    const [statusID, setStatusID] = useState("")

    return (
        <div className="modal-body">
            <div className="container-fluid">
                <div className="form-group row mb-1">
                    <label className="col-2 col-form-label custom-form-label pb-2"
                        htmlFor="status">
                        <FormattedMessage {...messages.order_status_label} />
                    </label>
                    <div className="col-10">
                        <OrderStatusSelect
                            multi={false}
                            placeholder={"Select status"}
                            value={statusID}
                            onChange={value => {
                                setStatusID(value)
                                props.onChange({statusID: value})
                            }}
                        />
                    </div>
                    <div className={"pt-4 text-right"}>
                        <em>
                            <FormattedMessage {...messages.refresh_description}/>
                        </em>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrdersUpdateStatus


// WEBPACK FOOTER //
// ./src/bulk/operations/OrdersUpdateStatusComponent.tsx